// import { ActionTypes } from "../action-type";
import { createSlice } from "@reduxjs/toolkit";


const initialState = {
    status: 'loading',
    mainMenu: null
};

export const mainMenuReducer = createSlice({
    name: "mainMenu",
    initialState,
    reducers: {
        setMainMenu: (state, action) => {
            state.status = "fulfill";
            state.mainMenu = action.payload.data;
        },

    }
});


export const { setMainMenu } = mainMenuReducer.actions;
export default mainMenuReducer.reducer;